import React, { useRef, useEffect } from "react";
import { MenuHeader, ArrowLeftIcon, IconButton } from "@activecollab/components";
import PropTypes from "prop-types";
import ResizeObserver from "resize-observer-polyfill";

export const Submenu = ({ onBack, onHeightChange, style, children, title }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (typeof onHeightChange === "function" && ref.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const { contentRect = {} } = entry;
          const { height = 0 } = contentRect;
          if (height > 0) {
            onHeightChange(height);
          }
        }
      });

      resizeObserver.observe(ref.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [onHeightChange]);

  return (
    <div
      style={style}
      ref={ref}
    >
      <MenuHeader
        title={title}
        leftElement={
          <IconButton
            onClick={onBack}
            variant="text gray"
            size="small"
          >
            <ArrowLeftIcon />
          </IconButton>
        }
      />
      {children}
    </div>
  );
};

Submenu.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func,
  onHeightChange: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.any,
};
